import { Component, OnInit } from '@angular/core';
import { GameBase } from 'app/common/gameBase';
import { BetInfoService } from 'app/providers/bet-info/bet-info.service';
import { Ball } from 'app/common/betBall';

@Component({
  selector: 'app-ssc-renxuan-rx4-zhixuan-fushi',
  templateUrl: './ssc-renxuan-rx4-zhixuan-fushi.component.html',
  styleUrls: ['./ssc-renxuan-rx4-zhixuan-fushi.component.css']
})
export class SscRenxuanRx4ZhixuanFushiComponent extends GameBase implements OnInit {

  constructor(
    public betInfoService: BetInfoService
  ) {
    super(betInfoService);

    /** 玩法面板选球状态 */
    this.btn_status_array = [
      [false, false, false, false, false, false, false, false, false, false],
      [false, false, false, false, false, false, false, false, false, false],
      [false, false, false, false, false, false, false, false, false, false],
      [false, false, false, false, false, false, false, false, false, false],
      [false, false, false, false, false, false, false, false, false, false]
    ];

    /** 快捷选号数组 */
    this.fast_option_array = [
      [false, false, false, false, false, false],
      [false, false, false, false, false, false],
      [false, false, false, false, false, false],
      [false, false, false, false, false, false],
      [false, false, false, false, false, false]
    ];

    /** 玩法面板数据 */
    this.lottery_data = [
      [
        new Ball(0),
        new Ball(1),
        new Ball(2),
        new Ball(3),
        new Ball(4),
        new Ball(5),
        new Ball(6),
        new Ball(7),
        new Ball(8),
        new Ball(9)
      ],
      [
        new Ball(0),
        new Ball(1),
        new Ball(2),
        new Ball(3),
        new Ball(4),
        new Ball(5),
        new Ball(6),
        new Ball(7),
        new Ball(8),
        new Ball(9)
      ],
      [
        new Ball(0),
        new Ball(1),
        new Ball(2),
        new Ball(3),
        new Ball(4),
        new Ball(5),
        new Ball(6),
        new Ball(7),
        new Ball(8),
        new Ball(9)
      ],
      [
        new Ball(0),
        new Ball(1),
        new Ball(2),
        new Ball(3),
        new Ball(4),
        new Ball(5),
        new Ball(6),
        new Ball(7),
        new Ball(8),
        new Ball(9)
      ],
      [
        new Ball(0),
        new Ball(1),
        new Ball(2),
        new Ball(3),
        new Ball(4),
        new Ball(5),
        new Ball(6),
        new Ball(7),
        new Ball(8),
        new Ball(9)
      ]
    ];
  }

  ngOnInit() {
  }

  /**
   * 判断是否完成选球，构成注单
   *
   * @returns {boolean}
   * @memberof SscRenxuanRx4ZhixuanFushiComponent
   */
  public is_selected_ball_completed(): boolean {

    let pos_array;
    let item;
    let arr;

    this.selected_ball_array = [];
    pos_array = this.balls_str.split('|');
    for (item of pos_array) {
      arr = item.split('');
      this.selected_ball_array.push(arr);
    }

    let selected_num = 0;
    for (let item of this.selected_ball_array) {
      if (item.length > 0) {
        selected_num++;
      }

      if (selected_num >= 4) {
        return true;
      }
    }

    return false;
  }

  /**
   * 计算注单数量
   *
   * @memberof SscRenxuanRx4ZhixuanFushiComponent
   */
  public calculate_bet_number() {
    let num = 0;
    let item;
    let arr = [];

    for (item of this.selected_ball_array) {
      if (item.length !== 0) {
        arr.push(item.length);
      }
    }

    for (let i = 0; i < arr.length - 3; i++) {
      for (let j = (i + 1); j < arr.length - 2; j++) {
        for (let k = (j + 1); k < arr.length - 1; k++) {
          for (let l = (k + 1); l < arr.length; l++) {
            num += arr[i] * arr[j] * arr[k] * arr[l];
          }
        }
      }
    }

    this.bet_num = num;
  }

}
